import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'evaluate'
})
export class EvaluatePipe implements PipeTransform {

  transform<T>(value: T, fn: (arg: T) => boolean): boolean {
    return fn(value);
  }

}
